class MailIspUtil {
    constructor() { }
}
// メールアドレス 利用可能文字チェック
// https://cloud.jira.unext-info.jp/browse/COM-5130
MailIspUtil.isAvailableUserNameCharacters = (value) => {
    // /^[a-z]{1}[a-z0-9_.-]*@$/;
    const regexp = new RegExp(/^[a-z]{1}[a-z0-9_.-]*$/);
    return regexp.test(value);
};
MailIspUtil.isValidUserNameLength = (value) => {
    return value.length >= 1 && value.length <= 30;
};
// パスワード 利用可能文字チェック
// https://cloud.jira.unext-info.jp/browse/COM-4349
MailIspUtil.isAvailablePasswordCharacters = (value) => {
    const regexp = new RegExp(/^[A-Za-z0-9!"#$%&'()*+,./:;<=>?@\[\\\]^_`{|}~]{1}[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@\[\\\]^_`{|}~]*$/);
    return regexp.test(value);
};
MailIspUtil.isValidPasswordLength = (value) => {
    return value.length >= 3 && value.length <= 16;
};
export default MailIspUtil;
